<div>
  <div style="display: block" [style.height.px]="chartHeight">
    <canvas
      baseChart
      [type]="chartType"
      [data]="data"
      [labels]="chartData.dataset.categories"
      [legend]="chartConfiguration.legend"
      [options]="chartConfiguration.options"
      style="background-color: white"
    >
    </canvas>
  </div>
</div>
